import {} from 'react';
export const HEADER_EVENT_CAPTION_CHANGE = 'page:header:change:caption';
